import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const general: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/general`),
};

export default general;
